import * as React from 'react'
import GoogleIcon from '@mui/icons-material/Google'
import MicrosoftIcon from '@mui/icons-material/Microsoft'
import Button from '@mui/material/Button'
import { AuthConfig } from 'src/auth.types'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
    btn_google: {
        backgroundColor: '#FEEFEF',
        color: '#D93025',
        border: '1px solid #D93025',
        '&:hover': {
            backgroundColor: '#fbe3e3',
            boxShadow: 'none'
        },
        fontWeight: 500,
        fontSize: '14px',
        textTransform: 'none' as const,
        borderRadius: '6px',
        padding: '6px 16px',
        width: '100%',
        display: 'flex',
        gap: '8px',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: 'none'
    },
    btn_microsoft: {
        backgroundColor: '#E7F0FE',
        color: '#2564CF',
        border: '1px solid #2564CF',
        '&:hover': {
            backgroundColor: '#d8e5fb',
            boxShadow: 'none'
        },
        fontWeight: 500,
        fontSize: '14px',
        textTransform: 'none' as const,
        borderRadius: '6px',
        padding: '6px 16px',
        width: '100%',
        display: 'flex',
        gap: '8px',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: 'none'
    }
}))

const externalLogin = (config: AuthConfig) => {
    const isGoogle = config.redirectUri.indexOf('/google/') !== -1
    const scope = `openid profile email${isGoogle ? '' : ' User.Read'}`
    const responseType = 'code'

    const url = new URL(config.authorizeUri)

    url.searchParams.set('client_id', config.clientId)
    url.searchParams.set('response_type', responseType)
    url.searchParams.set('response_mode', 'query')
    url.searchParams.set('redirect_uri', config.redirectUri)
    url.searchParams.set('scope', scope)

    window.location.href = url.href
}

export type ExternalLoginButtonProps = {
    provider: 'google' | 'microsoft'
    config: AuthConfig
}

export function ExternalLoginButton({ provider, config }: ExternalLoginButtonProps) {
    const isGoogle = provider === 'google'

    const { classes } = useStyles()

    return (
        <Button
            onClick={() => externalLogin(config)}
            className={isGoogle ? classes.btn_google : classes.btn_microsoft}
            // sx={styles}
            variant="outlined"
            startIcon={isGoogle ? <GoogleIcon /> : <MicrosoftIcon />}
        >
            Autenticação {isGoogle ? 'Google' : 'Microsoft'}
        </Button>
    )
}
